module.exports = __webpack_public_path__ + "onboarding-pkg-gruntgulp.89600160ed4b545f242070346406ff23.hashedasset.svg";